// Products Overlay Effect
if ($('.template-index').length || $('.template-product').length || $('.template-page--secret').length) {
	$('.js-overlay').hover(
		function() {
			$(this)
				.parent()
				.addClass('overlay-active');
		},
		function() {
			$(this)
				.parent()
				.removeClass('overlay-active');
		}
	);
}
